import React from "react";
import Slider from "@mui/material/Slider";
import { AppState } from "./Types";
import { rollPosition, valueRaw } from "./Functions";
import { Box, Stack } from "@mui/material";
import WindowOutlinedIcon from "@mui/icons-material/WindowOutlined";
import GridOnOutlinedIcon from "@mui/icons-material/GridOnOutlined";

function BoardControls({
  appState,
  setAppState,
}: {
  appState: AppState;
  setAppState: React.Dispatch<React.SetStateAction<AppState>>;
}) {
  const changeBoardSize = (event: Event, newSize: number | number[]) => {
    let newPos = rollPosition(newSize as number);
    setAppState({
      ...appState,
      pastRuns: [...appState.pastRuns, appState.pastMoves],
      boardSize: newSize as number,
      knightPosition: newPos,
      pastMoves: [newPos],
      countdown: 3,
      finished: false,
    });
  };

  return (
    <Box>
      <Stack spacing={2} direction="row" my={1.1} alignItems="center">
        <WindowOutlinedIcon />
        <Slider
          aria-labelledby="board-size-slider-label"
          aria-label="Board size markers"
          defaultValue={8}
          track={false}
          value={appState.boardSize}
          getAriaValueText={valueRaw}
          step={1}
          valueLabelDisplay="auto"
          min={5}
          max={20}
          shiftStep={1}
          onChange={changeBoardSize}
          valueLabelFormat={valueRaw}
        />{" "}
        <GridOnOutlinedIcon />
      </Stack>
    </Box>
  );
}

export default BoardControls;
